import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// เอา <StrictMode> ที่ครอบ <App /> ออก
root.render(<App />);
